import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { AllotmentListView } from "./allotment-list.view";
import { AllotmentListDataService } from "./allotment-list.data";
import { ContextService } from 'src/core/services/context.service';
import { ContractDataService } from 'src/app/products/contract/form/contract-form.data';

export class AllotmentListController extends React.Component<ControllerProps<any>, any> {

    protected dataService: AllotmentListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
	protected toast: ToastNotifications;
	@resolve
	protected contextService: ContextService;
	protected contractDataService: ContractDataService;

    public constructor(props) {
        super(props);
    }

	public componentDidMount() {
		this.dataService = AllotmentListDataService.make(this.contextService);
		this.contractDataService = ContractDataService.make(this.contextService);
        this.loadData();
    }
	@autobind
	private async deleteAllotment(items: any[]) {
		for (let deleteAllotment of items) {
			if ((deleteAllotment as AllotmentSummary).hasContracts) {
				this.contractDataService.addFilter('isDeleted', 'eq', false);
				this.contractDataService.addFilter('allotmentId', 'eq', deleteAllotment.id);
				this.contractDataService.addSorting('id', 'asc', true);
				this.contractDataService.pageSize = 255;
				let items = await this.contractDataService.load(query => query);
				items.forEach((item, i) => {
					item.allotmentId = null;
				});
			} 
		}
		let res= await this.contractDataService.save();
	}
    @autobind
    protected onItemDoubleClicked(item: AllotmentSummary) {
        this.props.history.push(`/products/allotment/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

	public render() {
		if (this.dataService == null) return null;
        return <AllotmentListView
            toast={this.toast}
            model={this.dataService}
            setBusy={this.props.setBusy}
			onItemDoubleClicked={this.onItemDoubleClicked}
			deleteAllotment={this.deleteAllotment}
            {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/list/allotment-list.controller.tsx